import React, { useEffect, useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { NAV_LINKS, scrollToId } from './homeData';

export const HomeNav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => { setOpen(false); requestAnimationFrame(() => requestAnimationFrame(() => scrollToId(id))); };

  return (
    <header className={`yv-nav ${scrolled ? 'is-scrolled' : ''}`} data-testid="home-nav">
      <div className="yv-container yv-nav-inner">
        <button className="yv-nav-logo" onClick={() => go('top')} aria-label="YOVAI home" data-testid="nav-logo">
          <img src="/yovai-logo-light.png" alt="YOVAI" />
        </button>
        <nav className="yv-nav-links" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="yv-nav-link" data-testid={`nav-${l.id}`}>
              {l.label}
            </button>
          ))}
        </nav>
        <div className="yv-nav-actions">
          <button onClick={() => go('contact')} className="yv-nav-contact" data-testid="nav-contact">Contact</button>
          <button onClick={() => go('contact')} className="yv-btn yv-btn-primary yv-btn-sm" data-testid="nav-apply-btn">
            <span className="yv-apply-long">Apply For A Consultation</span><span className="yv-apply-short">Apply Now</span> <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </button>
          <button
            className="yv-nav-toggle"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-controls="yv-mobile-menu"
            aria-label={open ? 'Close menu' : 'Open menu'}
            data-testid="nav-mobile-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div id="yv-mobile-menu" className="yv-mobile-menu" data-testid="nav-mobile-panel">
          {NAV_LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="yv-mobile-link" data-testid={`nav-mobile-${l.id}`}>
              {l.label}
            </button>
          ))}
          <button onClick={() => go('contact')} className="yv-mobile-link" data-testid="nav-mobile-contact">Contact</button>
        </div>
      )}
    </header>
  );
};
